import { createApi } from '@reduxjs/toolkit/query/react';

import { ContactUsFormPayload, ContactUsFormResponse } from '@/types/ContactUs';
import { ResponseError } from '@/types/Error';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

const contentTypes = {
  applicationJson: 'application/json',
};

export const contactUsApi = createApi({
  reducerPath: 'contactUsApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({ basePath: 'Home' }),
  tagTypes: ['ContactUs'],
  endpoints: builder => ({
    sendContactUsEmail: builder.mutation<ContactUsFormResponse, ContactUsFormPayload>({
      query: payload => ({
        url: `/SendContactUsEmail`,
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': contentTypes.applicationJson,
        },
      }),
      transformResponse: (response: ContactUsFormResponse) => response,
      transformErrorResponse: response => response as ResponseError,
    }),
  }),
});

export const { useSendContactUsEmailMutation } = contactUsApi;
